module.exports = __webpack_public_path__ + "img/zimmer-frei-3.92444fa9.jpg";